const apiUrl = "https://mitserver.app:5000";
module.exports = {
	apiUrl,
};
